import React from 'react';
import { ChevronDown } from 'lucide-react';

/** Apartado plegable para detalles técnicos. */
export function Disclosure({
  title,
  children,
  id
}: {
  title: string;
  children: React.ReactNode;
  id?: string;
}) {
  return <details id={id} className="group rounded-2xl border border-white/10 bg-white/[0.02] scroll-mt-32" data-id="element-1181" data-mp="36am7n7x9fwf2">
      <summary className="flex cursor-pointer list-none items-center justify-between gap-3 px-4 py-3.5 text-[15px] font-semibold text-gray-200 [&::-webkit-details-marker]:hidden" data-id="element-1182" data-mp="31bsslb2brxcs">
        {title}
        <ChevronDown className="h-4 w-4 shrink-0 text-gray-500 transition-transform duration-200 ease-out group-open:rotate-180" aria-hidden="true" data-id="element-1183" data-mp="3u0gk3odo3iys" />
      </summary>
      <div className="border-t border-white/5 px-4 py-4" data-id="element-1184" data-mp="3k17rayujgae0">{children}</div>
    </details>;
}
export type StatRow = {
  label: string;
  value?: string | number;
  note?: string;
};
export function StatList({
  rows
}: {
  rows: StatRow[];
}) {
  const visible = rows.filter(r => r.value !== undefined);
  if (!visible.length) return <p className="text-sm text-gray-500" data-id="element-1185" data-mp="1iubgze4rs9af">Sin datos en los archivos.</p>;
  return <dl className="grid gap-x-6 gap-y-3 sm:grid-cols-2" data-id="element-1186" data-mp="1ntedubalj97b">
      {visible.map(r => <div key={r.label} data-id="element-1187" data-mp="18wf3wgs9v49o">
          <dt className="text-xs text-gray-500" data-id="element-1188" data-mp="18x6ufd70ibt3">{r.label}</dt>
          <dd className="text-white tabular-nums" data-id="element-1189" data-mp="1dvi0rdy3m46k">
            {typeof r.value === 'number' ? r.value.toLocaleString('es-ES') : r.value}
            {r.note && <span className="ml-1.5 text-xs text-gray-500" data-id="element-1190" data-mp="103bklruy3x74">{r.note}</span>}
          </dd>
        </div>)}
    </dl>;
}